export default __webpack_public_path__ + "static/katie-bitmoji-6441d21610524bc520c5037a5ecb7d4f.png";